// extracted by mini-css-extract-plugin
module.exports = {"asideInfo":"side-info_asideInfo__Ge7Dy","links":"side-info_links__TDzq3","list":"side-info_list__UHjoM"};